import React from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";

import "@fontsource/rajdhani/600.css";
import "@fontsource/rajdhani/700.css";

export default function Feedback() {
  const formUrl = "https://forms.gle/MtdVnX1qM1Pp9SqV8";

  return (
    <Box bg="#08090C" color="white" minH="calc(100vh - 64px)">
      <Box
        position="relative"
        minH="calc(100vh - 64px)"
        display="flex"
        alignItems="center"
        backgroundImage="url('/images/HighresScreenshot00007.png')"
        alt="Velocity Protocol movement shooter gameplay image"

        backgroundSize="cover"
        backgroundPosition="center"
        px={{ base: 4, md: 6 }}
        py={{ base: 10, md: 28 }}
      >
        <Box position="absolute" inset={0} bg="rgba(0,0,0,0.1)" />

        <Container maxW="container.md" position="relative" zIndex={1} px={0}>
          <Box
            bg="rgba(0,0,0,0.5)"
            border="1px solid rgba(255,255,255,0.25)"
            borderRadius={{ base: "14px", md: "20px" }}
            p={{ base: 6, md: 12 }}
            textAlign="center"
            backdropFilter="blur(8px)"
          >
            <VStack spacing={{ base: 5, md: 6 }}>
              <Text
                color="gray.400"
                textTransform="uppercase"
                letterSpacing={{ base: "0.14em", md: "0.25em" }}
                fontWeight="700"
                fontSize={{ base: "xs", md: "sm" }}
              >
                Velocity Protocol Open Alpha
              </Text>

              <Heading
                color="white"
                fontSize={{ base: "4xl", md: "7xl" }}
                lineHeight="0.95"
                fontFamily="'Rajdhani', sans-serif"
                fontWeight="700"
                textTransform="uppercase"
              >
                Feedback
              </Heading>

              <Text
                color="gray.300"
                fontSize={{ base: "md", md: "xl" }}
                maxW="500px"
                fontWeight="500"
              >
                Tell us what you liked, what you did not, and what you would
                like to see improved.
              </Text>

              <Button
                as="a"
                href={formUrl}
                target="_blank"
                rel="noopener noreferrer"
                size="lg"
                bg="white"
                color="black"
                _hover={{
                  bg: "gray.300",
                  transform: "translateY(-2px)",
                }}
                px={10}
                h="56px"
                width={{ base: "100%", sm: "auto" }}
                maxW="360px"
                fontWeight="700"
                letterSpacing="0.08em"
                textTransform="uppercase"
              >
                Open Feedback Form
              </Button>

              <Text color="gray.300" fontSize="sm">
                Takes about 1 minute.
              </Text>
            </VStack>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
